import { useQuery } from "react-query";
import { listTelawahs } from "../api/endpoints/Telawahs/telawahs";
import TelawahModel from "../api/models/TelawahModel";
import { showApiErrorMessages } from "../helpers";

export function useTelawah() {
  const { data: telawahs } = useQuery(
    ["telawahs"],
    () => listTelawahs({ pagination: { pageSize: 200, pageNumber: 1 } }),
    {
      staleTime: Infinity,
      cacheTime: 0,
      select: (response) => {
        let telawahs: TelawahModel[] = [];
        if (response.isSuccess) {
          telawahs = TelawahModel.fromApiResponse(response.data);
        } else {
          showApiErrorMessages(response);
        }
        return telawahs;
      },
    }
  );
  const telawahsObject = telawahs?.reduce(
    (telawahMap: { [id: string]: string }, telawah: TelawahModel) => {
      telawahMap[`${telawah.id}`] = telawah.name!;
      return telawahMap;
    },
    {}
  );
  const telawahOptions = telawahs?.map((telawah: TelawahModel) => ({
    key: telawah.name!,
    value: `${telawah.id}`,
  }));
  const getTelawahById = (id: number) =>
    telawahs?.filter((telawah: TelawahModel) => telawah?.id === id);

  return { telawahs, getTelawahById, telawahOptions, telawahsObject };
}
